import { render, staticRenderFns } from "./AssetTransferNewFormBox.vue?vue&type=template&id=17165a3e"
import script from "./AssetTransferNewFormBox.vue?vue&type=script&lang=js"
export * from "./AssetTransferNewFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports